var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudiolevel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "32 22 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2564_509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.5296 34.1726C55.5296 40.5262 50.4052 45.6726 44.089 45.6726C37.7729 45.6726 32.6484 40.5262 32.6484 34.1726C32.6484 27.819 37.7729 22.6726 44.089 22.6726C50.4052 22.6726 55.5296 27.819 55.5296 34.1726Z",
    stroke: "#D8D5CC",
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6465 27.8342C46.6465 27.5439 46.479 27.2797 46.2164 27.1559C45.9538 27.032 45.6433 27.0709 45.4194 27.2556L41.2549 30.69H37.6914C37.2772 30.69 36.9414 31.0257 36.9414 31.44V36.9053C36.9414 37.3195 37.2772 37.6553 37.6914 37.6553H41.2549L45.4194 41.0896C45.6433 41.2744 45.9538 41.3132 46.2164 41.1894C46.479 41.0656 46.6465 40.8013 46.6465 40.511V27.8342ZM42.0014 32.0186L45.1465 29.4249V38.9204L42.0014 36.3267C41.8671 36.2159 41.6984 36.1553 41.5243 36.1553H38.4414V32.19H41.5243C41.6984 32.19 41.8671 32.1294 42.0014 32.0186Z",
    fill: "#1D1D1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4396 30.1945C49.1202 29.9307 48.6475 29.9757 48.3837 30.2951C48.1199 30.6144 48.1649 31.0871 48.4843 31.3509C49.2987 32.0238 49.816 33.0359 49.816 34.1797C49.816 35.3263 49.3107 36.3233 48.4984 36.9942C48.1791 37.2581 48.1341 37.7308 48.3979 38.0501C48.6617 38.3695 49.1344 38.4145 49.4538 38.1507C50.6006 37.2033 51.316 35.787 51.316 34.1797C51.316 32.5695 50.5841 31.14 49.4396 30.1945Z",
    fill: "#1D1D1B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2564_509",
    x: 0.148438,
    y: 0.172607,
    width: 91.8809,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2564_509"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.113725 0 0 0 0 0.113725 0 0 0 0 0.105882 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2564_509"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2564_509",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudiolevel);
export default __webpack_public_path__ + "static/media/audiolevel.be1bcf05b2de12b3f85aa2fc5d582f65.svg";
export { ForwardRef as ReactComponent };